
import {Component, Mixins,Prop} from "vue-property-decorator"
import Common from '@/mixins/common'

@Component({
  components: {
  }
})

export default class TemplateMembers extends Mixins(Common){
  @Prop({type: Array, default: () => {return []}}) private memberUserIds?: string[]
  @Prop({type: Object, default: () => {return {}}}) private memberMeta?: {}
  @Prop({type: String, default: ''}) private size?: '' | 'medium' | 'large'

  get userId(){
    return this.$store.getters.userId
  }

  get hasDeleteButton(){
    return typeof this.$listeners['update:memberUserIds'] === 'function'
  }

  get isSyncMemberMeta(){
    return typeof this.$listeners['update:memberMeta'] === 'function'
  }

  created(){
    //console.log(this.$listeners)
  }

  deleteUser(userId: string){
    if(! this.memberUserIds){
      return
    }

    let userIds = [...this.memberUserIds]
    const meta = {...(this.memberMeta || {})}

    if(userIds.includes(userId)){
      userIds =  userIds.filter((id) => {
         return userId !== id
      })

      this.$emit('update:memberUserIds', userIds)

      if(this.isSyncMemberMeta && meta[userId as keyof typeof meta]){
        delete meta[userId as keyof typeof meta]
        this.$emit('update:memberMeta', meta)
      }
    }
  }
}
